import { CrossIcon, PartialCheckmarkIcon, RoundedCheckmarkIcon } from '@ui/kit/icons';
import { wrapper, bulletIcon, item, bullet } from './atom.legend.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function PieChartLegend(props) {
  return /*#__PURE__*/jsxs("ul", {
    className: wrapper,
    "data-context": props.context,
    children: [props.withAnswered && /*#__PURE__*/jsx(Item, {
      state: "answered"
    }), props.withNotAnswered && /*#__PURE__*/jsx(Item, {
      state: "not-answered"
    }), props.withCorrect && /*#__PURE__*/jsx(Item, {
      state: "correct"
    }), props.withPartial && /*#__PURE__*/jsx(Item, {
      state: "partial"
    }), props.withIncorrect && /*#__PURE__*/jsx(Item, {
      state: "incorrect"
    })]
  });
}
function Item(props) {
  const label = (() => {
    switch (props.state) {
      case "answered":
        return "Besvaret";
      case "correct":
        return "Rigtig";
      case "incorrect":
        return "Forkert";
      case "not-answered":
        return "Ikke besvaret";
      case "partial":
        return "Delvist rigtig";
    }
  })();
  const icon = (() => {
    switch (props.state) {
      case "answered":
        return /*#__PURE__*/jsx("span", {
          className: bulletIcon
        });
      case "correct":
        return /*#__PURE__*/jsx(RoundedCheckmarkIcon, {});
      case "partial":
        return /*#__PURE__*/jsx(PartialCheckmarkIcon, {
          style: {
            marginTop: "0.5px",
            marginLeft: "0.5px"
          }
        });
      case "incorrect":
        return /*#__PURE__*/jsx(CrossIcon, {
          strokeWidth: 1.5,
          height: 10
        });
    }
  })();
  return /*#__PURE__*/jsxs("li", {
    className: item,
    children: [/*#__PURE__*/jsx("span", {
      className: bullet,
      "data-state": props.state,
      children: icon
    }), /*#__PURE__*/jsx("span", {
      children: label
    })]
  });
}

export { PieChartLegend };
//# sourceMappingURL=atom.legend.js.map
